
<div class="row" *ngIf="ListView">
  <div class="col-md-12 padding-right-0px padding-left-0px">
    <div class="card">
      <div class="card-header wh-header font-size-16px font-weight-normal border-left-clinical padding-top-6px padding-left-15px">
        Health Records
      </div>
      <div class="card-body padding-all-0px">
        <div class="row">
          <div class="col-md-12">
            <div class="table-component">
              <div class="table-responsive overflow-x-hidden">


                <table class="table table-striped margin-left-zero">

                  <thead class="">
                    <tr>
                      <th class="td-width-100px">Date</th>

                      <th class="">Forms</th>

                      <!--<th class="td-width-3px">User</th>-->
                      <th></th>
                    </tr>
                  </thead>
                  <tbody class="table-body">
                    <tr *ngFor="let l of CurrentOTFormsByFormattedCodeController">



                      <td class="padding-right-0px padding-top-0px padding-bottom-0px">{{l.RegistrationDate|date:'dd-MM-yyyy'}}</td>

                      <td class="padding-top-0px padding-bottom-0px">{{l.TemplateName}}</td>
                      <!--<td>{{l.PatientName}}</td>-->
                      <td class="padding-top-0px padding-bottom-0px"> <button (click)="OpenForm(l)" class="btn font-size-13px actions-btn-prime  margin-right-auto">Open</button></td>
                    </tr>

                  </tbody>

                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>

<!--<div class="row margin-top-10" *ngIf="backtolist">
  <div class="card">
    <div class="card-header wh-header font-size-16px font-weight-normal border-left-clinical padding-top-6px padding-left-10px">
      <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Health Records"
         (click)="Back()"><i class="fas fa-angle-double-left font-size-19px"></i></a> Medical Histroy
    </div>
    <div class="card-body padding-all-0px">
      <div *ngIf="FormData" class="margin-top-10">


        <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let l of FormData;let RowIndex = index">

          <div [id]="'accordion'+RowIndex">
            <div class="card-header wh-header font-size-16px  padding-top-0px padding-bottom-0px border-left-clinical padding-l-8px padding-right-0px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
              <div class="row">
                <div class="col-md-3">
                  <h5 class="mb-0">
                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                            aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                      {{l.Title}}

                    </button>

                  </h5>
                </div>
                <div class="col-md-6">
                  <a class="nav-link-hand education-navlink margin-right-10px " title="Edit" (click)="displytextedit(l)" *ngIf="l.Title=='Findings'">
                    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                  </a>
                </div>
              </div>


            </div>
            <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                 [attr.data-parent]="'#accordion'+RowIndex">
              <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                <div class="row col-md-12 card" *ngFor="let f of l.Fields">


                  <div class="card-header wh-header font-size-14 padding-l-8px padding-t-6px padding-bottom-0px padding-right-0px" *ngIf="f.isHeader">
                    {{f.Title}}
                  </div>
                  <div class="card-body padding-bottom-0px padding-top-0px margin-left-zero">
                    <div *ngIf="f.isSubHeader">
                      <label class="font-size-14 margin-bottom-0px">{{f.Title}}</label>
                    </div>
                    <div *ngIf="f.isTextField">
                      <div class="row">
                        <div class="col-md-6 padding-right-0px">
                          <label class="font-size-12px margin-bottom-0px">{{f.Title}}</label>
                        </div>:
                        <div class="col-md-5">
                          <label class="font-size-12px margin-bottom-0px"> {{f.Value}}</label>
                        </div>
                      </div>


                    </div>
                    <div *ngIf="f.isSubChild">
                      <div class="row">
                        <div class="col-md-6">
                          <label class="font-size-12px margin-bottom-0px">{{f.Title}}</label>
                        </div>:
                        <div class="col-md-5">
                          <label class="font-size-12px margin-bottom-0px"> {{f.Value}}</label>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="f.Remarks">
                      <label class="margin-left-10px margin-bottom-0px">{{f.Remarks}}</label>
                    </div>
                    <div *ngIf="f.HasSeparator">
                      <div class="border-bottom-light"></div>
                    </div>
                  </div>
                </div>

               

              </div>
            </div>
          </div>
         
        </div>
        
      </div>
    </div>
  </div>
</div>-->
<!--<div class="row">
  <div class="col-md-12">
    <viewedittext [reportCode]="SelectedPatientFormCode.PatientReportCode" [FormattedCode]="SelectedPatientFormCode.FormattedCode" [TemplateName]="SelectedPatientFormCode.TemplateName" [Date]="SelectedPatientFormCode.RegistrationDate" [Sign1]="SelectedPatientFormCode.Sign1Name" [Sign2]="SelectedPatientFormCode.Sign2Name" *ngIf="edittextscreen"></viewedittext>
  </div>
</div>-->




